<script setup lang="ts">
import { RouterLink, type RouteLocationRaw } from 'vue-router'

withDefaults(defineProps<{ to: RouteLocationRaw; exact?: boolean }>(), {
  exact: true,
})
</script>

<template>
  <RouterLink
    class="h-7 rounded-corner-8 px-3 py-1.5 text-center text-sm-12px-default text-text-subtlest hover:bg-background-gray-subtlest-hovered"
    :to="to"
    v-bind="
      exact
        ? { exactActiveClass: 'bg-background-gray-subtlest text-text!' }
        : { activeClass: 'bg-background-gray-subtlest text-text!' }
    "
  >
    <slot />
  </RouterLink>
</template>
